var map = {
	"./back.svg": 911,
	"./facebook.svg": 902,
	"./github.svg": 866,
	"./gmail.svg": 343,
	"./instagram.svg": 673,
	"./linkedin.svg": 500,
	"./resume.svg": 943,
	"./tech/androidstudio.svg": 386,
	"./tech/clang.svg": 680,
	"./tech/cpp.svg": 392,
	"./tech/csharp.svg": 216,
	"./tech/css.svg": 857,
	"./tech/firebase.svg": 111,
	"./tech/flutter.svg": 630,
	"./tech/git.svg": 554,
	"./tech/googlecloud.svg": 612,
	"./tech/html.svg": 415,
	"./tech/java.svg": 846,
	"./tech/javascript.svg": 736,
	"./tech/mongodb.svg": 917,
	"./tech/mysql.svg": 394,
	"./tech/nodejs.svg": 541,
	"./tech/php.svg": 603,
	"./tech/react.svg": 772,
	"./tech/scenebuilder.svg": 809,
	"./tech/unity.svg": 727,
	"./twitter.svg": 961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 254;